import { Injectable } from "@angular/core";
import { ITranslation } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "../shared/api/api.service";
import { BaseApiService } from "../shared/api/baseApi.service";

@Injectable({
  providedIn: "root",
})
export class LanguagesApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Languages", // Theme !
      [], // Post route paths
      ["dashboard/translations"], // Get route paths
      [], // Put route paths
      [] // Delete route paths
    );
  }

  public list(): Observable<ITranslation[]> {
    return this.api.get("languages") as Observable<ITranslation[]>;
  }

  public getTranslations(terms: string): Observable<ITranslation[]> {
    return this.api.get(this.readRoutes[0], { terms: terms }) as Observable<ITranslation[]>;
  }
}
